<script setup>
import { computed, ref, watch } from 'vue';
import DailyView from './DailyView.vue';
import WeeklyTimeLine from './WeeklyTimeLine.vue';
import { getTodayDate } from './utils';

const props = defineProps({
    initWeek: {
        type: Array,
        default: () => []
    },
    showPastItems: {
        type: Boolean,
        default: false
    },
    showFutureItems: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['handleStream', 'loadMoreItems', 'loadMorePastItems']);

const activeDay = ref(getTodayDate());
const week = ref([...props.initWeek]);

watch(
    () => props.initWeek,
    (newWeek) => {
        week.value = [...newWeek];
    }
);

const showDay = (date) => {
    activeDay.value = date;
};

const handleShowStream = (id) => {
    emit('handleStream', id);
};

const loadMoreItems = () => {
    emit('loadMoreItems');
};
const loadMorePastItems = () => {
    emit('loadMorePastItems');
};

const showActiveDay = computed(() => {
    if (!week.value.length) {
        return {
            date: '',
            items: []
        };
    }

    const activeDayIndex = week.value.findIndex((day) => day.date === activeDay.value);

    return week.value[activeDayIndex !== -1 ? activeDayIndex : 0];
});
</script>

<template>
    <div v-if="week.length > 0">
        <WeeklyTimeLine
            :week="week"
            :active-day="activeDay"
            :show-past-items="showPastItems"
            :show-future-items="showFutureItems"
            @show-day="showDay"
            @load-more-items="loadMoreItems"
            @handle-stream="handleShowStream"
            @load-more-past-items="loadMorePastItems"
        />
        <div class="sm:hidden">
            <div class="xs:h-4 md:h-10"></div>
            <DailyView :active-day="showActiveDay" @handle-stream="handleShowStream" />
        </div>
    </div>
    <div v-else class="text-center text-gray-500">{{ $t('no_data') }}</div>
</template>
